import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthProvider } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MemoryOutlinedIcon from '@mui/icons-material/MemoryOutlined';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';

import Navbar from "../components/Navbar";

const Home = (props) => {
    const [ authorized, authType, token ] = useAuthProvider();
    const [ controller ] = useMaterialUIController();
    const { config, user, darkMode } = controller;
    const navigate = useNavigate();
    React.useEffect(() => {
        if(!authorized){
            return navigate("/landing", { replace: true });
        }
    });
    if(!authorized || !user.superAdmin){
        return null;
    }
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={config.hideLayout ? 0 : 3}>
                <Navbar />
                <MDBox
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                    mb={2}
                >
                    <MDTypography variant="h3">Olympus-Grid Dashboard</MDTypography>
                    <MDButton variant="contained" color="dark">
                        <CachedOutlinedIcon sx={{marginRight: "8px"}} />
                        Refresh
                    </MDButton>
                </MDBox>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6} lg={4}>
                        <Card>
                            <MDBox display="flex" justifyContent="space-between" p={2}>
                                <MDBox textAlign="left" lineHeight={1.25}>
                                    <MDBox lineHeight={1.25}>
                                        <MDTypography variant="button" fontWeight="bold" color="dark">
                                            System Status
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox lineHeight={1.25}>
                                        <MDTypography variant="button" fontWeight="light" color="success">
                                            Optimal
                                        </MDTypography>
                                    </MDBox>
                                </MDBox>
                                <MDBox
                                    variant="gradient"
                                    color={(darkMode ? "white" : "dark")}
                                    borderRadius="0px"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    width="4rem"
                                    height="4rem"
                                    sx={{background: "transparent"}}
                                >
                                    <MemoryOutlinedIcon />
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <Card>
                            <MDBox display="flex" justifyContent="space-between" p={2}>
                                <MDBox textAlign="left" lineHeight={1.25}>
                                    <MDBox lineHeight={1.25}>
                                        <MDTypography variant="button" fontWeight="bold" color="dark">
                                            Security Status
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox lineHeight={1.25}>
                                        <MDTypography variant="button" fontWeight="light" color="success">
                                            All Systems Secure
                                        </MDTypography>
                                    </MDBox>
                                </MDBox>
                                <MDBox
                                    variant="gradient"
                                    color={(darkMode ? "white" : "dark")}
                                    borderRadius="0px"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    width="4rem"
                                    height="4rem"
                                    sx={{background: "transparent"}}
                                >
                                    <GppGoodOutlinedIcon />
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <Card>
                            <MDBox display="flex" justifyContent="space-between" p={2}>
                                <MDBox textAlign="left" lineHeight={1.25}>
                                    <MDBox lineHeight={1.25}>
                                        <MDTypography variant="button" fontWeight="bold" color="dark">
                                            Active Processes
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox lineHeight={1.25}>
                                        <MDTypography variant="button" fontWeight="light" color="text">
                                            52
                                        </MDTypography>
                                    </MDBox>
                                </MDBox>
                                <MDBox
                                    variant="gradient"
                                    color={(darkMode ? "white" : "dark")}
                                    borderRadius="0px"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    width="4rem"
                                    height="4rem"
                                    sx={{background: "transparent"}}
                                >
                                    <MonitorHeartOutlinedIcon />
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <Card>
                            <MDBox display="flex" justifyContent="space-between" p={2}>
                                <MDBox textAlign="left" lineHeight={1.25}>
                                    <MDBox lineHeight={1.25}>
                                        <MDTypography variant="button" fontWeight="bold" color="dark">
                                            Plugins Loaded
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox lineHeight={1.25}>
                                        <MDTypography variant="button" fontWeight="light" color="text">
                                            14 Active
                                        </MDTypography>
                                    </MDBox>
                                </MDBox>
                                <MDBox
                                    variant="gradient"
                                    color={(darkMode ? "white" : "dark")}
                                    borderRadius="0px"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    width="4rem"
                                    height="4rem"
                                    sx={{background: "transparent"}}
                                >
                                    <ExtensionOutlinedIcon />
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <Card>
                            <MDBox display="flex" justifyContent="space-between" p={2}>
                                <MDBox textAlign="left" lineHeight={1.25}>
                                    <MDBox lineHeight={1.25}>
                                        <MDTypography variant="button" fontWeight="bold" color="dark">
                                            Nodes Connected
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox lineHeight={1.25}>
                                        <MDTypography variant="button" fontWeight="light" color="text">
                                            4 Total
                                        </MDTypography>
                                    </MDBox>
                                </MDBox>
                                <MDBox
                                    variant="gradient"
                                    color={(darkMode ? "white" : "dark")}
                                    borderRadius="0px"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    width="4rem"
                                    height="4rem"
                                    sx={{background: "transparent"}}
                                >
                                    <ComputerOutlinedIcon />
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4}>
                        <Card>
                            <MDBox display="flex" justifyContent="space-between" p={2}>
                                <MDBox textAlign="left" lineHeight={1.25}>
                                    <MDBox lineHeight={1.25}>
                                        <MDTypography variant="button" fontWeight="bold" color="dark">
                                            SLA Warnings
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox lineHeight={1.25}>
                                        <MDTypography variant="button" fontWeight="light" color="warning">
                                            2 Warnings
                                        </MDTypography>
                                    </MDBox>
                                </MDBox>
                                <MDBox
                                    variant="gradient"
                                    color={(darkMode ? "white" : "dark")}
                                    borderRadius="0px"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    width="4rem"
                                    height="4rem"
                                    sx={{background: "transparent"}}
                                >
                                    <NotificationsNoneOutlinedIcon />
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
                <Grid container spacing={3} mt={2}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Card>
                            <MDBox display="flex" justifyContent="space-between" pt={2} pl={2}>
                                <MDBox textAlign="left" lineHeight={1.25}>
                                    <MDTypography variant="button" fontWeight="bold" color="dark">
                                        Recent Events
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                            <MDBox display="flex" justifyContent="space-between" pt={2} pl={2}>
                                <MDBox textAlign="left" lineHeight={1.25}>
                                    <MDTypography display="flex" alignItems="center" variant="button" fontWeight="light" color="text">
                                        <CheckOutlinedIcon sx={{marginRight: "5px"}} />New plugin deployed:&nbsp;<strong>sign-in-with-apple</strong>
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                            <MDBox display="flex" justifyContent="space-between" pt={1} pl={2}>
                                <MDBox textAlign="left" lineHeight={1.25}>
                                    <MDTypography display="flex" alignItems="center"  variant="button" fontWeight="light" color="text">
                                        <CheckOutlinedIcon sx={{marginRight: "5px"}} />Node 3 promoted to master
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                            <MDBox display="flex" justifyContent="space-between" pt={1} pl={2}>
                                <MDBox textAlign="left" lineHeight={1.25}>
                                    <MDTypography display="flex" alignItems="center"  variant="button" fontWeight="light" color="text">
                                        <CheckOutlinedIcon sx={{marginRight: "5px"}} />SLA exceeded on Hermes webhook #242
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                            <MDBox display="flex" justifyContent="space-between" pt={1} pl={2}>
                                <MDBox textAlign="left" lineHeight={1.25}>
                                    <MDTypography display="flex" alignItems="center"  variant="button" fontWeight="light" color="text">
                                        <CheckOutlinedIcon sx={{marginRight: "5px"}} />AI Provider connected: OpenAI
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                            <MDBox display="flex" justifyContent="space-between" pt={1} pl={2} pb={2}>
                                <MDBox textAlign="left" lineHeight={1.25}>
                                    <MDTypography display="flex" alignItems="center"  variant="button" fontWeight="light" color="text">
                                        <CheckOutlinedIcon sx={{marginRight: "5px"}} />Agent Athena excecuted 'optimize' pathway
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
}

export default Home;